import React from 'react';
import './index.scss';

import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { inject, observer } from 'mobx-react';

@inject('internal')
@observer
export default class BoxClients extends React.Component {

    handleChange = (event) => {

        var indexRemove = 0;
        var tmpListClientsMine = this.props.internal.dataForSimpeTable.clients_list['mine'];
        var tmpListClientsOther = this.props.internal.dataForSimpeTable.clients_list['other'];
        var clients_list = {mine:[], other:[]}

        var succes = false;
        this.props.internal.dataForSimpeTable.clients_list['mine'].filter(obj => {
            if (obj.name === event.target.value) {
                tmpListClientsOther.push(obj);
                tmpListClientsMine.splice(indexRemove, 1);
                succes = true
            }
            indexRemove++;
            return null
        })

        if (succes === false) {
            indexRemove = 0;
            this.props.internal.dataForSimpeTable.clients_list['other'].filter(obj => {
                if (obj.name === event.target.value) {
                    tmpListClientsMine.push(obj);
                    tmpListClientsOther.splice(indexRemove, 1);
                }
                indexRemove++;
                return null
            })
        }

        clients_list["mine"] = tmpListClientsMine
        clients_list["other"] = tmpListClientsOther

        this.props.internal.changeAdministratorClients(clients_list);

        this.props.update();
        
    }
    
    render() {
        return (
                <Paper className={'list-clients'}>
                    <h6>{this.props.title}</h6>
                    <Divider/>
                    <div className={'list-clients-content'}>
                        <List>
                            {this.props.data ? this.props.data[this.props.property].map((data, index) => {
                                return(
                                <ListItem key={data.id} dense onChange={this.handleChange} className={'list-item'}>
                                    <input id={data.name} type="checkbox" value={data.name} defaultChecked={this.props.checked}/>
                                    {/* <ListItemText primary={`${data.name}`} /> */}
                                    <label htmlFor={data.name}>{data.name}</label>
                                </ListItem>
                                )
                                }
                            ) : null}
                        </List>
                    </div>
                </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/boxClients/index.js